import Input from "../../Control/Input";
import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { Wrapper } from "../../Control/Flexbox";
import RefreshIcon from "@material-ui/icons/Refresh";
import { ExpandLess, ExpandMore, Remove, Add } from "@material-ui/icons";
const InspectionStandard = (props) => {
  const { ppapData } = props;
  const [render, setRender] = useState(false);
  const [isSpecs, setIsSpecs] = useState([]);
  function handleSpec(e, index) {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    ppapData.ins_standard[index][e.target.name] = value;
  }

  function append(where, data) {
    ppapData[where].push(data);
    setRender((prev) => !prev);
  }

  function remove(where, index) {
    if (
      window.confirm("Are you sure you want to delete Inspection Standard?")
    ) {
      ppapData[where].splice(index, 1);
      setRender((prev) => !prev);
    }
  }

  const hideSpecs = (index) => {
    setIsSpecs((prev) => [...prev, index]);
  };

  const openSpecs = (index) => {
    const values = [...isSpecs];
    const idx = values.indexOf(index);
    values.splice(idx, 1);
    setIsSpecs(values);
  };

  return (
    <div className="specs-container" style={{ marginBottom: "3rem" }}>
      <Wrapper>
        <Input
          type="text"
          name="ins_prepared_by"
          label="Prepared By"
          onChange={(e) => {
            ppapData.ins_prepared_by = e.target.value;
          }}
          defaultValue={ppapData.ins_prepared_by}
        />
        <Input
          type="text"
          name="ins_approved_by"
          label="Approved By"
          onChange={(e) => {
            ppapData.ins_approved_by = e.target.value;
          }}
          defaultValue={ppapData.ins_approved_by}
        />
      </Wrapper>
      <div>
        <Wrapper
          justify="space-between"
          style={{ borderBottom: "1px solid #c80202" }}
        >
          <p className="card-btn-para" style={{ color: "#c80202" }}>
            • ADD{" "}
            <span style={{ fontWeight: 400, color: "black" }}>
              INSPECTION STANDARD
            </span>
          </p>
          <Wrapper>
            <Wrapper
              style={{
                height: "45px",
                width: "50px",
                backgroundColor: "#c80202",
                color: "white",
                cursor: "pointer",
              }}
              onClick={() => {
                append("ins_standard", {
                  s_no: ppapData.ins_standard.length + 1,
                  key: uuidv4(),
                });
              }}
              justify="center"
            >
              <Add />
            </Wrapper>
            <Wrapper
              style={{
                height: "45px",
                width: "50px",
                backgroundColor: "#151a1d",
                color: "white",
                cursor: "pointer",
              }}
              justify="center"
              onClick={() => {
                ppapData?.ins_standard?.sort(
                  (a, b) => Number(a.s_no) - Number(b.s_no)
                );
                setRender((prev) => !prev);
              }}
            >
              <RefreshIcon />
            </Wrapper>
          </Wrapper>
        </Wrapper>
      </div>

      {ppapData.ins_standard.map((spec, index) => (
        <div
          key={spec.key}
          style={{
            marginBottom: "0.3rem",
            marginTop: "0.6rem",
            padding: "0rem",
            border: "1px solid #f0f2f0",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              background: "#fafafa",
              alignItems: "center",
            }}
            className="spec-header"
          >
            <Wrapper>
              <Input
                type="Number"
                name="s_no"
                onBlur={(e) => handleSpec(e, index)}
                defaultValue={spec.s_no}
                style={{ width: "80px" }}
              />
              <Wrapper
                justify="center"
                style={{
                  marginLeft: "0.4rem",
                  fontSize: "0.9rem",
                  textTransform: "uppercase",
                }}
              >
                {spec.dimension}
              </Wrapper>
            </Wrapper>
            <Wrapper>
              {isSpecs.includes(index) ? (
                <Wrapper
                  style={{
                    height: "45px",
                    width: "50px",
                    backgroundColor: "#3f51b5",
                    cursor: "pointer",
                    color: "white",
                  }}
                  justify="center"
                  onClick={() => openSpecs(index)}
                >
                  <ExpandLess />
                </Wrapper>
              ) : (
                <Wrapper
                  style={{
                    height: "45px",
                    width: "50px",
                    backgroundColor: "#3f51b5",
                    cursor: "pointer",
                    color: "white",
                  }}
                  justify="center"
                  onClick={() => hideSpecs(index)}
                >
                  <ExpandMore />
                </Wrapper>
              )}
              <Wrapper
                style={{
                  height: "45px",
                  width: "50px",
                  backgroundColor: "#151a1d",
                  color: "white",
                  cursor: "pointer",
                }}
                justify="center"
                onClick={() => remove("ins_standard", index)}
              >
                <Remove />
              </Wrapper>
            </Wrapper>
          </div>
          {isSpecs.includes(index) && (
            <div className="specs-field">
              <Wrapper>
                <Input
                  type="text"
                  name="parameter"
                  placeholder="Parameter"
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.parameter}
                />
                <Input
                  type="text"
                  name="specification"
                  placeholder="Specification"
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.specification}
                />

                <Input
                  type="text"
                  name="ins_method"
                  placeholder="Inspection Method"
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.ins_method}
                />
                <Input
                  type="text"
                  name="freq"
                  placeholder="Frequency"
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.freq}
                />
                <Input
                  type="text"
                  name="sample_size"
                  placeholder="Sample Size"
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.sample_size}
                />
                <Input
                  type="text"
                  name="lot_size"
                  placeholder="Lot Size"
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.lot_size}
                />
                <Input
                  type="text"
                  name="sample"
                  placeholder="Sample"
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.sample}
                />
                <Input
                  type="text"
                  name="accept"
                  placeholder="Accept"
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.accept}
                />
              </Wrapper>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
export default InspectionStandard;
